import { Pipe, PipeTransform } from '@angular/core';
import { LayerDto } from "../../../../../api/src/creative-unit-package/models/layer/layer.dto";
import { LayersUtils } from "../../../../../api/src/creative-unit-package/utils/layers.utils";

@Pipe({
	name: 'flattenLayers'
})
export class FlattenLayersPipe implements PipeTransform {
	transform(layers: LayerDto[]): LayerDto[] {
		return LayersUtils.flattenLayers(layers);
	}
}
